import AuthApp from "./AuthApp.vue";
import AuthCallback from "./pages/AuthCallback.vue";

export const authRoutes = [
    {
        path: "/auth",
        component: AuthApp,
        children: [{ path: "callback", component: AuthCallback }],
    },
    {
        path: "/auth_et",
        component: AuthApp,
        children: [{ path: "callback", component: AuthCallback }],
    },
];
